import { render, staticRenderFns } from "./ProgramInstructorAlert.vue?vue&type=template&id=7da72dac&scoped=true&"
import script from "./ProgramInstructorAlert.vue?vue&type=script&lang=js&"
export * from "./ProgramInstructorAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da72dac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
